import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  openFirmwareTools() {
    buryPoint.event({
      action: 'Portal',
      eventCategory: '重要固件升级查询工具'
    });
  },
  openFirmwareBatch() {
    buryPoint.event({
      action: 'Portal',
      eventCategory: '固件工具批量配置'
    });
  },
  openFirmwareUpdate() {
    buryPoint.event({
      action: 'Portal',
      eventCategory: '固件工具批量升级'
    });
  }
};
